import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import dashboardService from "../../services/dashboard-service";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin, Tooltip } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment from "moment/moment";
import Select from "react-select";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardProjection = () => {


  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [showApplicationDay, setShowApplicationDay] = useState(false)

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [farmId, setFarmId] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////
  const [total, setTotal] = useState(0)
  const [bunch, setBunch] = useState(0)

  const [serieProyectionDay, setSerieProyectionDay] = useState([])
  const [listProyectionDay, setListProyectionDay] = useState([])
  const [listProyectionBunchDay, setListProyectionBunchDay] = useState([])

  const [serieProyectionLot, setSerieProyectionLot] = useState([])
  const [listProyectionLot, setListProyectionLot] = useState([])
  const [listProyectionBunchLot, setListProyectionBunchLot] = useState([])


  registerLocale("es", es);
  const start_date = moment().add(-7, 'd').endOf("day").toDate();
  const end_date = moment().startOf("day").toDate();

  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const [title, setTitle] = useState("Proyección de cosecha");


  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);



  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////


  const changeShowApplicationDate = (e) => {
    setShowApplicationDay(e.target.checked)
  }


  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////



  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };



  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };





  /// PRIMERAS APLICACIONES POR LOTE
  const firstApplicationHectareLot = async (start, end, weight, malogro) => {
    setTitle("Total a cosechar por lote")
    setSerieProyectionLot([])
    setListProyectionLot([])
    setListProyectionBunchLot([])

    const result = await dashboardService.firstApplicationByLot(start, end, farmId, lotId, sectionId, selectedLotes,"$totalFirst");
    let listLot = [];
    let listApp = [];
    let listBunch = [];
    let accumulation = 0
    let accumulationBunch = 0
    if (result) {
      result.map((item) => {
        const lot = item.lotName.toLowerCase();
        //const app_1 = item.totalApplicationsType1

        const app_1 = Math.round(item.total * (1 - (malogro / 100)));
        const kilos = app_1 * weight;

        accumulation = accumulation + kilos
        accumulationBunch = accumulationBunch + app_1

        listLot.push(lot)
        listBunch.push(app_1)
        listApp.push(kilos.toFixed(2))
      });

    }
    setSerieProyectionLot(listLot)
    setListProyectionLot(listApp)
    setListProyectionBunchLot(listBunch)
  };




  /// PRIMERAS APLICACIONES POR LOTE
  const firstApplicationByDay = async (start, end, weight, futureDays, malogro) => {

    console.log("futureDays:", futureDays)

    setTitle("Proyección de cosecha")
    setSerieProyectionDay([])
    setListProyectionDay([])
    setListProyectionBunchDay([])
    const result = await dashboardService.firstApplicationByDay(start, end, farmId, lotId, sectionId, selectedLotes);
    let listLot = [];
    let listApp = [];
    let listBunches = [];
    let accumulation = 0
    let accumulationBunch = 0
    if (result) {
      result.map((item) => {


        const present = item._id;
        const future = moment(present).add(futureDays, 'days').format('YYYY-MM-DD');
        const presentDayFormat = moment(present).add(0, 'days').format('YYYY-MM-DD');
        const future_format = formatDate(future)
        const present_format = formatDate(presentDayFormat)
        
        if(showApplicationDay)
          listLot.push(`Polinización:${present_format}\nCosecha:${future_format}`)
        else
          listLot.push(`${future_format}`)


        const app_1 = Math.round(item.totalApplicationsType1 * (1 - (malogro / 100)));
        const kilos = app_1 * weight
        accumulation = accumulation + kilos
        accumulationBunch = accumulationBunch + app_1

        listApp.push(kilos.toFixed(2))
        listBunches.push(app_1)
      });

      setTotal(accumulation)
      setBunch(accumulationBunch)
    }
    setSerieProyectionDay(listLot)
    setListProyectionDay(listApp)
    setListProyectionBunchDay(listBunches)
  };




  const futureProyection = () => {
    let daysTetx = getValues("days")
    if (daysTetx == "") {
      daysTetx = 0;
      setValue("days", 0)
    }
    const days = parseInt(daysTetx)

    let weightTetx = getValues("weight")
    if (weightTetx == "") {
      weightTetx = 0;
      setValue("weight", 0)
    }
    const weight = parseFloat(weightTetx)



    let malogroTetx = getValues("malogro")
    if (malogroTetx == "") {
      malogroTetx = 0;
      setValue("malogro", 0)
    }
    const malogro = parseFloat(malogroTetx)




    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    const futureDays = days
    firstApplicationByDay(start, end, weight, futureDays, malogro)
    firstApplicationHectareLot(start, end, weight, malogro)

  };







  const currentProyection = () => {
    let daysTetx = getValues("days")
    if (daysTetx == "") {
      daysTetx = 0;
      setValue("days", 0)
    }
    const days = parseInt(daysTetx)

    let weightTetx = getValues("weight")
    if (weightTetx == "") {
      weightTetx = 0;
      setValue("weight", 0)
    }
    const weight = parseFloat(weightTetx)


    let malogroTetx = getValues("malogro")
    if (malogroTetx == "") {
      malogroTetx = 0;
      setValue("malogro", 0)
    }
    const malogro = parseFloat(malogroTetx)

    let start = moment(startDate).subtract(days, 'days').startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).subtract(days, 'days').endOf("day").format('YYYY-MM-DD');

    const futureDays = days
    firstApplicationByDay(start, end, weight, futureDays, malogro)
    firstApplicationHectareLot(start, end, weight, malogro)

  };



  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };



  useEffect(() => {
    getLisFarm();
    setValue("days", 190)
    setValue("weight", 5)
    futureProyection()
  }, []);



  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Proyección de cosecha</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form
            className="form-react"
            defaultValue={{ weight: 40 }}

          >
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>





              <div className="col-12 col-sm-3">
                <div className="row">

                  <div className=" col-6 col-sm-6">
                    <label className="text-secondary fw-bold">Desde</label>
                    <br />
                    <DatePicker
                      locale="es"
                      dateFormat="yyyy-MM-dd"
                      className="form-control text-secondary"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                    />
                  </div>

                  <div className=" col-6  col-sm-6">
                    <label className="text-secondary fw-bold">Hasta</label>
                    <br />
                    <DatePicker
                      locale="es"
                      dateFormat="yyyy-MM-dd"
                      className="form-control 
                text-secondary"
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </div>

                </div>
              </div>





              <div className="col-12 col-sm-3">
                <div className="row">

                  <div className=" col-6 col-sm-6">
                    <label className="text-secondary fw-bold">Días cosecha</label>
                    <br />
                    <input
                      type="number"
                      className="form-control"
                      {...register("days")}
                    />
                  </div>

                  <div className=" col-6 col-sm-6">
                    <label className="text-secondary fw-bold">Peso promedio</label>
                    <br />
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      {...register("weight")}
                    />
                  </div>


                </div>
              </div>






              <div className="col-12 col-sm-4">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>



              <div className=" col-6 col-sm-2 mt-1">
                <label className="text-secondary fw-bold">Malogro (%)</label>
                <br />
                <input
                  type="number"
                  step="any"
                  className="form-control"
                  {...register("malogro")}
                />
              </div>


              <div className="mt-2 col-6 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeShowApplicationDate(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Fecha aplicacion</label>
                </div>
              </div>


              <div className="col-12 col-sm-3 d-none">
                <div className="row">

                  <div className=" col-12 col-sm-6">
                    <label className="text-secondary fw-bold">Desde past</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      {...register("startDatePast")}
                    />
                  </div>

                  <div className=" col-12 col-sm-6">
                    <label className="text-secondary fw-bold">hasta Past</label>
                    <br />
                    <input
                      type="text"
                      className="form-control"
                      {...register("endDatePast")}
                    />
                  </div>


                </div>
              </div>

              <div className=" col-12 col-sm-2 mt-1">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Tooltip title={`Muestra la proyección de cosecha de las flores de primera polinizadas en el rango de tiempo, pasado  ${getValues("days")} dias `}>
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={() => futureProyection()}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Proyeccion de cosecha
                  </button>
                </Tooltip>

              </div>




              <div className=" col-12 col-sm-2 mt-1">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />

                <Tooltip title={`Muestra lo que se va a cosechar en el rango de tiempo, dependendiendo de las flores de primera polinizadas ${getValues("days")} dias atras`}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => currentProyection()}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Cosecha en campo
                  </button>
                </Tooltip>
              </div>





            </div>



          </form>
        </div>





        <div className={total == 0 ? "d-none" : "col-12 col-sm-12 text-center "}>
          <div className=" mb-3 bg-white rounded"  >
            <label style={{ fontSize: "20px", fontWeight: "bold", color: "#2693FF" }}>kilogramos: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "20px", fontWeight: "bold" }}>{total.toLocaleString()} Kg</label><br />


            <label style={{ fontSize: "20px", fontWeight: "bold", color: "#2693FF" }}>Racimos: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "20px", fontWeight: "bold" }}>{bunch.toLocaleString()}</label>
          </div>
        </div>






        <div className={showApplicationDay ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartTwoRef}
              title="Proyección kilos por día"
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=" "
              showSerieValue={showLineValues}
              valuesX={serieProyectionDay}
              valuesY={listProyectionDay}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "proyeccion-kilos-dia.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={showApplicationDay ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartThreeRef}
              title="Proyección racimos por día"
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=" "
              showSerieValue={showLineValues}
              valuesX={serieProyectionDay}
              valuesY={listProyectionBunchDay}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "proyeccion-racimos-dia.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>




        <div className={showApplicationDay ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartOneRef}
              title="Proyección de kilos por lote"
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=" "
              showSerieValue={showLineValues}
              valuesX={serieProyectionLot}
              valuesY={listProyectionLot}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "proyeccion-kilos-lote.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>



        <div className={showApplicationDay ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartFourRef}
              title="Proyección de racimos por lote"
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=" "
              showSerieValue={showLineValues}
              valuesX={serieProyectionLot}
              valuesY={listProyectionBunchLot}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartFourRef, "proyeccion-racimos-lote.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>








      </div>
    </div>
  );
};

export default DashboardProjection;
